<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.shipmentRule" mode="text" status="primary"/>
      </div>
      <div slot="extra">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="fetch()"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </div>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:packTypes}" field="packType" title="business.label.packType" width="120"/>
        <vxe-column field="shipOrder" title="business.label.shipOrder" width="100"/>
        <vxe-column field="storer.name" title="business.label.storer"/>
        <vxe-column field="orderType.name" title="business.label.orderType"/>
        <vxe-column field="itemType.name" title="business.label.itemType"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <shipment-rule-editor ref="editor" :item-types="itemTypes" :order-types="orderTypes" :pack-types="packTypes" :storers="storers" @success="fetch()"/>
  </div>
</template>

<script>
import { deleteOne, findAll } from '@/api/Api'
import { ShipmentRule } from '@/api/dto/config/ShipmentRule'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import ShipmentRuleEditor from '@/views/basedata/storageroom/ShipmentRuleEditor.vue'

export default {
  name: 'ShipmentRuleTable',
  components: { ShipmentRuleEditor },
  data() {
    return {
      loading: false,
      data: [],
      storageRoom: new StorageRoom()
    }
  },
  props: {
    packTypes: {
      type: Array,
      default: []
    },
    storers: {
      type: Array,
      default: []
    },
    orderTypes: {
      type: Array,
      default: []
    },
    itemTypes: {
      type: Array,
      default: []
    }
  },
  methods: {
    fetch(storageRoom) {
      this.loading = true
      if (storageRoom) {
        this.storageRoom = storageRoom
      }
      findAll('shipmentRuleFactory', { 'storageRoom.ids': [this.storageRoom.id] }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new ShipmentRule(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.$refs.editor.add(this.storageRoom)
    },
    edit(row) {
      this.$refs.editor.edit(row)
    },
    remove(row) {
      this.loading = true
      deleteOne('shipmentRuleDeleter', { id: row.id }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.deleteSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>